import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { bulkDelete, endBulkDelete } from '../../store/actions/companies';
import BulkDeleteModal from 'components/modals/bulk_delete_modal';

export class CompaniesBulkDeleteModal extends React.Component {
  static propTypes = {
    bulkDelete: PropTypes.bool.isRequired,
    selectedCompanyIds: PropTypes.func.isRequired,
    onBulkDelete: PropTypes.func.isRequired,
    onCancelBulkDelete: PropTypes.func.isRequired
  };

  render() {
    const { bulkDelete, selectedCompanyIds, onCancelBulkDelete, onBulkDelete } = this.props;

    return (
      <BulkDeleteModal
        entityCount={(selectedCompanyIds || []).length}
        entityName="Companies"
        shown={bulkDelete}
        onCancel={onCancelBulkDelete}
        onDelete={onBulkDelete}
      />
    );
  }
}

const mapStateToProps = state => ({
  bulkDelete: state.people.startBulkDelete,
  selectedCompanyIds: state.selectList.selectedCompanyIds
});

const mapDispatchToProps = {
  onBulkDelete: bulkDelete,
  onCancelBulkDelete: endBulkDelete
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesBulkDeleteModal);
